// Shared builder for the customer install snippet.

function runtimeConfig() {
  try {
    return window.__AW_RUNTIME_CONFIG__ || {};
  } catch {
    return {};
  }
}

export function widgetServerUrl() {
  const runtime = runtimeConfig();
  return (
    String(runtime.widgetServerUrl || runtime.apiBaseUrl || "").trim() ||
    String(process.env.REACT_APP_SERVER_URL || process.env.REACT_APP_API_BASE_URL || "").trim() ||
    "https://accss.net"
  ).replace(/\/$/, "");
}

// Non-blocking loader: the widget is fetched only after the host page finished loading,
// so an outage/slowness on our server can never delay rendering or the page "load" event.
// data-aw-loader lets the widget report that the site uses the current snippet.
export function buildEmbedSnippet(siteKey) {
  const src = `${widgetServerUrl()}/widget/embed.js`;
  return [
    "<!-- Accss Accessibility (non-blocking) -->",
    "<script>",
    `(function(w,d){var u=${JSON.stringify(src)},k=${JSON.stringify(String(siteKey || ""))};` +
      `function l(){if(d.querySelector('script[src="'+u+'"]'))return;var s=d.createElement("script");` +
      `s.src=u;s.async=true;s.setAttribute("data-site-key",k);s.setAttribute("data-aw-loader","v2");(d.body||d.head).appendChild(s);}` +
      `function q(){(w.requestIdleCallback||function(f){setTimeout(f,1)})(l,{timeout:2000});}` +
      `if(d.readyState==="complete")q();else w.addEventListener("load",q);})(window,document);`,
    "</script>",
  ].join("\n");
}

// Installation methods reported by the widget that can slow the customer's site when Accss is down
export const LEGACY_INSTALL_METHODS = ["legacy-sync", "legacy-defer", "legacy-async"];

export function needsInstallUpgrade(site) {
  return LEGACY_INSTALL_METHODS.includes(String(site?.install_method || ""));
}
